import React from 'react';
import { BadgeSlot } from './BadgeSlot';
import { type BadgeSlotModel } from '../../../utils/adventurePresentation';

interface BadgeWallDialogProps {
  title: string;
  badges: BadgeSlotModel[];
  onClose: () => void;
}

export const BadgeWallDialog: React.FC<BadgeWallDialogProps> = ({ title, badges, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
    <div className="w-full max-w-2xl rounded-[32px] bg-white p-6 shadow-2xl md:p-8">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-400">我的勋章墙</p>
          <h2 className="mt-2 text-2xl font-black text-slate-900">{title}</h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-full border border-slate-200 px-3 py-1.5 text-sm text-slate-500 hover:bg-slate-50"
        >
          关闭
        </button>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-5">
        {badges.map((badge) => (
          <div key={badge.id} className="rounded-3xl border border-slate-100 bg-slate-50/70 p-4 text-center">
            <div className="flex justify-center">
              <BadgeSlot badge={badge} />
            </div>
            <p className="mt-3 text-sm font-bold text-slate-800">{badge.name}</p>
            <p className="mt-1 text-xs text-slate-500">{badge.hint}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
